// extracted by mini-css-extract-plugin
export default {"new-email-cont":"NewTemplate_new-email-cont__-H9Vi"};